// PATCH oct21-ui-fix2: tidy a City value before it is saved
// "Burnaby, BC V5C 3S7" -> "Burnaby", "vancouver " -> "Vancouver", "SURREY BC" -> "Surrey"
var PROV = /^(BC|B\.C\.|AB|SK|MB|ON|QC|NB|NS|PE|PEI|NL|YT|NT|NU)$/i;
export function cleanCity(v) {
  var s = String(v == null ? "" : v).replace(/\s+/g, " ").trim();
  if (!s) return s;
  s = s.split(",")[0].trim();
  s = s.replace(/\b[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d\b/g, "").replace(/\b\d{5}(-\d{4})?\b/g, "").replace(/\s+/g, " ").trim();
  var words = s.split(" ");
  if (words.length > 1 && PROV.test(words[words.length - 1])) words.pop();
  s = words.join(" ").replace(/[\s.,;:-]+$/, "").trim();
  if (s === s.toLowerCase() || s === s.toUpperCase()) {
    s = s.toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }
  return s;
}
